import { render } from "./Abordagem.vue?vue&type=template&id=5b3d9492"
import script from "./Abordagem.vue?vue&type=script&lang=js"
export * from "./Abordagem.vue?vue&type=script&lang=js"

import "./Abordagem.vue?vue&type=style&index=0&id=5b3d9492&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__